module.exports = __webpack_public_path__ + "media/images/icons/rocket-d73dc122942f0f44a7e2b984499450e1.png";